import { useQuery } from '@tanstack/react-query'
import { httpGetRoadmapActivities } from '@/features/roadmaps/http/roadmap.http'
import { QUERY_KEYS } from '@/query-client'

interface UseGetRoadmapActivitiesParams {
	dateFrom: string
	dateTo: string
}

/** The window is part of the key, so a different range is a different cache entry. */
export const useGetRoadmapActivities = (
	params: UseGetRoadmapActivitiesParams
) =>
	useQuery({
		queryKey: [QUERY_KEYS.GET_ROADMAP_ACTIVITIES, params],
		queryFn: () => httpGetRoadmapActivities(params)
	})
